<template>
  <div class="img_share">
    <img src="../../../static/img/login-top.png" class="share_img">
    <div class="button_wapper">
      <van-button type="danger" round class="dl_button">下载APP参与聊天</van-button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      
    }
  },
  created() {
    },
  mounted() {
    console.log(wx)
    
  },
}
</script>
<style lang="scss" scoped>
  .img_share{
    .share_img{
      height: 100%;
      width: 100vw;
    }
    .button_wapper{
      width: 100%;
      display: flex;
      justify-content: center;
      position: fixed;
      top: 50%;
      .dl_button{
        width: 21.25rem;
        height: 3.5rem;
      }
    }
  }
</style>